export const Envs = {
  NX_COOKIE_DOMAIN: process.env['NX_COOKIE_DOMAIN'] ?? 'localhost',
}
